/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["div.spinner[_ngcontent-%COMP%]{display:flex;justify-content:center;padding:4rem}"];
export { styles as styles };
